export const themeData2 = {
  showRating: true,
  ratingBg: '#B94E57',
  showBtn: true,
  btnTextColor: '#fff',
  btnHoverTextColor: '#fff',
  btnHoverBgColor: '#988062',
  btnBgColor: '#988062',
  borderRadius: '0',
  borderColor: '#988062',
  addedCartText: 'Added to cart',
  addCartText: 'Add to cart',
  showSelectBox: true,
  selectBorderColor: '#B1B1B1',
  selectColor: '#000000',
  soldOutText: 'Sold Out',
  soldOutTextColor: '#fff',
  soldOutBgColor: '#FFFFFF',
  soldOutPosition: 'top-right',
  titlePorition: 'flex-start',
  bgColor: '#FFFFFF',
  TitleColor: '#988062',
  bgImgColor: '',
  productTitleColor: '#000',
  priceColor: '#B94E57',
  originalPriceColor: '#B1B1B1',
  heightDesktopImage: '236',
  widthDesktopImage: '236',
  heightMobileImage: '236',
  widthMobileImage: '236'
};
